import { Component, EventEmitter, Output, input, model, ChangeDetectionStrategy } from '@angular/core';
import { GaugeBarComponent, GaugeBarData } from '../gauge-bar/gauge-bar.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'time-counter-tile',
  templateUrl: 'time-counter-tile.component.html',
  standalone: true,
  styleUrls: ['./time-counter-tile.component.scss'],
  imports: [IonicModule, TranslateModule, GaugeBarComponent, NgClass, ProgressBarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeCounterTileComponent {
  gaugeData = input<GaugeBarData[]>([]);
  title = input<string>('');
  minutesDone = input<number>(0);
  maxMinutes = input<number>(100);
  disabled = input<boolean>(false);
  displayDetails = model<boolean>(false);

  convertMinutesToTime(minutes: number): string {
    minutes = Math.abs(minutes);
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const formattedMins = mins.toString().padStart(2, '0');
    return `${hours}h${formattedMins}`;
  }

  get timeToDisplay(): string {
    return this.convertMinutesToTime(this.minutesDone());
  }

  get timePercent(): number {
    return (this.minutesDone() * 100) / this.maxMinutes();
  }

  get isDisplayingDetails() {
    return this.displayDetails() && this.minutesDone() > 0;
  }

  onChangeDetailsBtnClick() {
    this.displayDetails.update((previous) => !previous);
  }
}
